export const CATEGORIES = [
  {
    name: 'Magazines, Newspapers & Catalogs',
    link: 'magazines',
    icon: 'magazines',
    examples: 'ua-example-magazines.png',
    categories: ['Magazines & Newspapers'],
  },
  {
    name: 'Loyalty Programs',
    link: 'loyalty-programs',
    icon: 'rewards',
    examples: 'ua-example-loyalty.png',
    categories: ['Loyalty Programs'],
  },
  {
    name: 'Schools & Alumni Associations',
    link: 'schools',
    icon: 'schools',
    examples: 'ua-example-schools.png',
    categories: ['Schools'],
  },
  {
    name: 'Political, Professional & Social Organizations',
    link: 'political-professional',
    icon: 'profes',
    examples: 'ua-example-political.png',
    categories: [
      'Political Organizations',
      'Professional Organizations',
      'Social Organizations',
    ],
  },
  {
    name: 'Charities & Non-profits',
    link: 'charities',
    icon: 'charity',
    examples: 'ua-example-charities.png',
    categories: ['Charities & Public Service'],
  },
];
